import { ImpactProviderMapResults } from "@app/projects/results/common/mapping"
import { getProviderGapStatusDecorator, ProviderGapStatus } from "@app/shared/providers/utils"
import ProviderBadge from "@app/shared/ProviderBadge"
import { JSX } from "react"
import { ProviderCard, ProviderCardProps } from "./ProviderCard"
import { IMPACT_PROVIDER_CARD_HIGHLIGHT_BACKGROUND_COLOR_DANGER, IMPACT_PROVIDER_CARD_HIGHLIGHT_BACKGROUND_COLOR_SUCCESS, IMPACT_PROVIDER_CARD_HIGHLIGHT_BACKGROUND_COLOR_WARNING, IMPACT_PROVIDER_CARD_HIGHLIGHT_BORDER_COLOR_DANGER, IMPACT_PROVIDER_CARD_HIGHLIGHT_BORDER_COLOR_SUCCESS, IMPACT_PROVIDER_CARD_HIGHLIGHT_BORDER_COLOR_WARNING } from "./NetworkCoverageMapsColors"
import { ProjectionProviderType } from "@app/projects/enumerators"

export const ImpactProviderCard = (
  {isSelected, passPercentage, provider, onClick }: ProviderCardProps
): JSX.Element => {

  const gapStatusDecorator = getProviderGapStatusDecorator(
    (provider as ImpactProviderMapResults).gainsPercent,
    (provider as ImpactProviderMapResults).impactsPercent,
    provider.servesPercent,
    passPercentage
  )

  let highlightedStyles = {};
 
  if (isSelected) 
  {
    if (gapStatusDecorator == ProviderGapStatus.Success) {
      highlightedStyles =  {
        backgroundColor: IMPACT_PROVIDER_CARD_HIGHLIGHT_BACKGROUND_COLOR_SUCCESS,
        borderColor: IMPACT_PROVIDER_CARD_HIGHLIGHT_BORDER_COLOR_SUCCESS,
        borderStyle: 'solid',
        borderWidth: '3px'
      };
    } else if (gapStatusDecorator == ProviderGapStatus.Warning) {
      highlightedStyles =  {
        backgroundColor: IMPACT_PROVIDER_CARD_HIGHLIGHT_BACKGROUND_COLOR_WARNING,
        borderColor: IMPACT_PROVIDER_CARD_HIGHLIGHT_BORDER_COLOR_WARNING,
        borderStyle: 'solid',
        borderWidth: '3px'
      };
    } else if (gapStatusDecorator == ProviderGapStatus.Danger) {
      highlightedStyles =  {
        backgroundColor: IMPACT_PROVIDER_CARD_HIGHLIGHT_BACKGROUND_COLOR_DANGER,
        borderColor: IMPACT_PROVIDER_CARD_HIGHLIGHT_BORDER_COLOR_DANGER,
        borderStyle: 'solid',
        borderWidth: '3px'
      };
    }
  }

  return (
    <ProviderCard containerClassName={`${gapStatusDecorator}`} highlightedStyles={highlightedStyles} isSelected={isSelected}  provider={provider} onClick={onClick}>
      <div className="d-flex flex-row">
        <p className="mr-3"><strong>Gains:</strong> {(provider as ImpactProviderMapResults).gainsPercent}%</p>
        <p><strong>Impacts:</strong> {(provider as ImpactProviderMapResults).impactsPercent}%</p>
      </div>
      <div className="d-flex flex-row">
        <div className="mr-2">
          <ProviderBadge providerNetworkType={(provider as ImpactProviderMapResults).providerNetworkType} />
        </div>
        {(provider as ImpactProviderMapResults).projectionType == ProjectionProviderType.Target && (
          <ProviderBadge
            providerNetworkType={(provider as ImpactProviderMapResults).projectionType} />
        )}
      </div>
    </ProviderCard>
  )
}